import React from 'react'
import { useNavigate } from 'react-router-dom'

const FormLogin = () => {

  const navigate = useNavigate()

  const login = () => {
    localStorage.setItem("token", true)
    navigate("/")
  }

  return (
    <div className='w-full h-full flex flex-col justify-center items-center'>
      <div className='relative w-[717px] h-[446px] bg-white shadow-inner rounded-[32px] shadowLoginform'>
        {/* title */}
        <div className='w-full flex justify-center'>
          <div className='w-[257px] h-[62px] bg-[#FFC427] rounded-lg transform -translate-y-[31px] flex justify-center items-center'>
            <span className='text-white font-bold text-3xl'>Inicio de sesión</span>
          </div>
        </div>
        {/* form */}
        <div className='absolute top-0 w-full h-full flex flex-col justify-center items-center'>
          <input
            placeholder='Número de empleado'
            className='w-[611px] h-[48px] pl-3 bg-[#e6e6e6] text-[#9a9a9a] text-xl font-normal focus:outline-none' type="text" />
          <input
            placeholder='Contraseña'
            className='w-[611px] h-[48px] pl-3 mt-8 bg-[#e6e6e6] text-[#9a9a9a] text-xl font-normal focus:outline-none' type="password" />
          <button
            onClick={() => login()}
            className='mt-8 w-[329px] h-[68px] text-white bg-[#686868] text-3xl font-bold rounded-lg'>
            Iniciar sesión
          </button>

        </div>
      </div>
      <div className='mt-[48px] w-[368px] h-[23px] bg-[#282828] bg-opacity-20 blur-md'></div>
    </div>
  )
}

export default FormLogin
